import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user/user.store'
import scenario from './modules/scenario/scenario.store'
import debug from './modules/debugger/debugger.store'
import ui from './modules/ui.store'
import { actionTypes } from './store.type'
import $const from '@/utils/const'

let types = actionTypes

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isShowLoading: false,
        // navigation: window.innerWidth > 1264,
        navigation: false,
        version: '0.1',
        authenticationService:
            process.env.VUE_APP_AUTHENTICATION_SERVICE ||
            $const.AuthenticationService.OPEN_ID,
        openIdConfig: {
            authorization_endpoint: '',
            end_session_endpoint: ''
        },
        bot: null,
        botList: []
    },
    mutations: {
        [types.LOADING]: (state, payload) => {
            state.isShowLoading = payload
        },
        [types.TOGGLE_NAVIGATION]: (state) => {
            state.navigation = !state.navigation
        },
        [types.NAVIGATION] (state, val) {
            state.navigation = val
        },
        [types.BOT] (state, val) {
            state.bot = val
        },
        [types.BOT_LIST] (state, val) {
            state.botList = val
        },
        [types.OPEN_ID_CONFIG] (state, val) {
            state.openIdConfig = val
        }
    },
    actions: {
        [types.LOADING]: (context, payload) => {
            context.commit(types.LOADING, payload)
        },
        [types.TOGGLE_NAVIGATION]: (context) => {
            context.commit(types.TOGGLE_NAVIGATION)
        },
        [types.NAVIGATION] (context, payload) {
            context.commit(types.NAVIGATION, payload)
        },
        [types.BOT_LIST] (context, payload) {
            context.commit(types.BOT_LIST, payload)
        },
        [types.BOT] (context, payload) {
            context.commit(types.BOT, payload)
        },
        [types.OPEN_ID_CONFIG] (context, payload) {
            context.commit(types.OPEN_ID_CONFIG, payload)
        }
    },
    modules: { user, scenario, debug, ui },
    getters: {
        loading: state => state.isShowLoading,
        profile: state => state.user.profile,
        token: state => state.user.token,
        version: state => state.version
    }
})

export default store
